var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "invoice-summary font-outfit pb-5 text-base" },
    [
      _c("div", { staticClass: "w-full mb-4 font-normal flex justify-end" }, [
        _vm._v("Total hours: "),
        _c("span", { staticClass: "font-medium ml-2 block min-w-20" }, [
          _vm._v(_vm._s(_vm.totalHours)),
        ]),
      ]),
      _c("div", { staticClass: "w-full mb-4 font-normal flex justify-end" }, [
        _vm._v("Total amount due before taxes: "),
        _c("span", { staticClass: "font-medium ml-2 block min-w-20" }, [
          _vm._v("$" + _vm._s(_vm.totalAmountDue)),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }